import React from "react";
import styled from "styled-components";

const AnimationBoxContainer = styled.div.attrs(({ start, duration, animationsDuration, selected, disabled, isLast }) => ({
    style: {
        left: `${start / animationsDuration * 100}%`,
        width: `calc(${duration / animationsDuration * 100}% + 1px)`,
        backgroundColor: selected ? "#ffffff" : "#DBE9F0",
        cursor: selected ? "move" : "default",
        opacity: disabled ? 0.3 : 1,
        borderBottom: isLast ? "1px solid #999" : "none",
        borderLeft: start > 0 ? "1px solid #999" : "none"
    }
}))`
        height: 100%;
        border-right: 1px solid #999;
        position: absolute;
        top: 0px;
        color: #333;
        margin-right: 1px;
`;

const AnimationBoxDurationLabel = styled.span`
        right: 1px;
        top: 0;
        position: absolute;
        font-family: monospace;
        font-size: 10px;
`;

const AnimationBoxNameLabel = styled.span`
        left: 50%;
        top: 50%;
        position: absolute;
        font-size: 12px;
        transform: translate(-50%, -50%);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 80%;
        text-align: center;
`;

export function AnimationBox({ animation, selected, animationsDuration, onMouseDown, isLast }) {
    return (
        <AnimationBoxContainer
            start={animation.start}
            duration={animation.duration}
            selected={selected}
            disabled={animation.disabled}
            animationsDuration={animationsDuration}
            onMouseDown={event => onMouseDown(event, false)}
            isLast={isLast}
        >
            <AnimationBoxDurationLabel>
                {(animation.duration / 1000).toFixed(1)}s
            </AnimationBoxDurationLabel>
            <AnimationBoxNameLabel>
                {animation.name}
            </AnimationBoxNameLabel>
        </AnimationBoxContainer>
    );
}
